<form *ngIf="instructionForm" [formGroup]="instructionForm">
    <textarea class="form-control"
              formControlName="instruction" (blur)="updateInstruction();"
              i18n-placeholder="@@ModuleInstructions.Placeholder"
              placeholder="ModuleInstructions.Placeholder">
    </textarea>
</form>
